import React from 'react';
import { cn } from '@/lib/twUtils';

const widths = {
  /** Griglie e sezioni piene */
  default: 'max-w-[77.5rem]', // 1240px
  /** Blocchi a due colonne, prezzi */
  narrow: 'max-w-[65rem]', // 1040px
  /** Testo lungo, FAQ, pannelli CTA */
  prose: 'max-w-[56.25rem]', // 900px
  /** Hero centrati */
  hero: 'max-w-[62.5rem]', // 1000px
} as const;

export interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  width?: keyof typeof widths;
  /** Disattiva il padding orizzontale quando lo gestisce la sezione */
  bleed?: boolean;
  as?: React.ElementType;
}

/** Larghezza massima e gutter orizzontali coerenti in tutto il sito. */
const Container = ({
  width = 'default',
  bleed = false,
  as: Tag = 'div',
  className,
  ...props
}: ContainerProps) => (
  <Tag className={cn('mx-auto w-full', widths[width], !bleed && 'px-6', className)} {...props} />
);

export default Container;
